import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home/home.vue'
import IntelligentControl from '@/views/Solution/intelligentControl.vue'
import RiskControl from '@/views/Solution/riskControl.vue'
import Audit from '@/views/Solution/audit.vue'
import Partner from '@/views/Partner/partner.vue'
import About from '@/views/About/about.vue'
import Ito from '@/views/ITO/ito.vue'




Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '*',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      title: '杭州邦睿科技有限公司',
      content: {
        keywords: '杭州邦睿科技有限公司,浙江邦睿科技有限公司',
        description: '杭州邦睿科技有限公司拥有大量核心研发与自身团队,专注于对大数据实时流的研发,拥有丰富的本地化实施经验,已与多家银行合作,发挥热数据价值。'
      }
    }
  },
  {
    path: '/intelligentAudit',
    name: 'Audit',
    component: Audit,
    meta: {
      title: '杭州邦睿科技有限公司',
      content: {
        keywords: '智能审计,',
        description: '邦盛科技智能审计是针对机构的审计管理、审计作业、技术分析等应用需求，建立的一套集成了智能化技术、审计体系运作管理、个性化订制服务等在内强大的管理系统。'
      }
    }
  },
  {
    path: '/intelligentControl',
    name: 'IntelligentControl',
    component: IntelligentControl,
    meta: {
      title: '杭州邦睿科技有限公司',
      content: {
        keywords: '智能运营风控,防范诈骗赌博等违规操作',
        description: '邦盛科技以监管关注重点,行业重大案件和银行内控制度规范为设计蓝本,基于长期业务积累及行业经验,形成特征指标体,结合大数据分析、人工会智能技术堆起T+1、准实时、试时风险检测体系,提升运营风控管理效率。'
      }
    }
  },
  {
    path: '/riskControl',
    name: 'RiskControl',
    component: RiskControl,
    meta: {
      title: '杭州邦睿科技有限公司',
      content: {
        keywords: '银行交易反诈骗,风险监控',
        description: '邦盛科技针对条码支付、对公收款、对公付款、跨境支付、国际贸易、平台商户、普惠金融等交易银行产品业务开展过程中面临的欺诈风险进行事中监控,对可疑的欺诈商户和团伙进行识别和控制,甄别优质客户,清除劣质客户,保障交易银行业务的正常开展。'
      }
    }
  },
  {
    path: '/partner',
    name: 'Partner',
    component: Partner,
    meta: {
      title: '杭州邦睿科技有限公司',
      content: {
        keywords: '银行合作伙伴,风险监控',
        description: '邦盛科技针依靠对风险的监控能力与优秀的热数据处理能力与中国农业银行,中国建设银行,中邮政储蓄银行交通银行,招商银行,浦发银行,中国光大银行等30余家银行达成合作伙伴关系,同时银联商户,银联电子支付,杭州市民卡等十余种第三方支付渠道达成合作关系,与国泰君安证券,中信证券等十余种证券与保险企业达成合作关系。'
      }
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: '杭州邦睿科技有限公司',
      content: {
        keywords: '杭州邦睿科技有限公司,企业简介,企业招聘',
        description: '杭州邦睿科技有限公司成立于2015年07月15日，注册资本5000万元，注册地位于浙江省杭州市滨江区长河街道建业路511号华创大厦14层1403室，法定代表人为汪陈笑。经营范围包括技术开发、技术服务、技术咨询、成果转让：计算机软硬件、计算机系统集成、电子产品。'
      }
    }
  },
  {
    path: '/ito',
    name: 'Ito',
    component: Ito
  },
]

const router = new VueRouter({
  routes, mode: 'history'
})

router.beforeEach((to, from, next) => {
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
});

export default router
